import React, { useEffect } from 'react';
import { shutdown } from '@intercom/messenger-js-sdk';
import { CircularProgress } from '@mui/material';
import queryClient from 'src/queryClient';
import { trackLogOut } from 'src/utils/mixpanel';
import { clearDivisions } from 'src/utils/divisionStorage';
import { getSsoReferrer, getApiHost, clearAuthFlowData } from 'src/utils/ssoReferrer';
import { clearAuthMethod } from 'src/utils/authVersion';

const SignOut = () => {
  useEffect(() => {
    // Clear local state
    try {
      shutdown();
      trackLogOut();
      localStorage.removeItem('x-sl-signin-user-email');
      clearAuthMethod();
      clearDivisions();
      clearAuthFlowData();
      queryClient.clear();
    } catch (e) {
      console.warn('SignOut cleanup error:', e);
    }

    const referrer = getSsoReferrer();
    window.location.href = `https://${getApiHost()}/api/auth/v2/logout?referrer=${referrer}`;
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: '16px',
        fontSize: '18px',
        fontFamily: 'Geist, sans-serif'
      }}
    >
      <CircularProgress size={48} />
      Signing out...
    </div>
  );
};

export default SignOut;
